import { IbDesk } from '@frontends/feature-ib';
import { Navigate } from 'react-router';
import useAuth from '@/hooks/useAuth';
import useIsIbDeskAvailable from '@/hooks/useIsIbDeskAvailable';

// IbDeskProvider is mounted above the layout by IbDeskGateway (ProtectedLayout)
export const IbDeskPage = () => {
  const { client } = useAuth();
  const isIbDeskAvailable = useIsIbDeskAvailable();

  if (client === undefined) {
    return null;
  }

  if (!isIbDeskAvailable) {
    return <Navigate to="/" replace />;
  }

  return <IbDesk />;
};
